var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23.5,
    fill: "white",
    stroke: "#FAEAEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8491 16.0036C15.8491 14.8958 15.8491 14.3419 16.0816 14.0366C16.2841 13.7706 16.5937 13.606 16.9289 13.5861C17.3136 13.5633 17.7775 13.8706 18.7053 14.485L30.7798 22.4815C31.5464 22.9893 31.9298 23.2431 32.0634 23.5631C32.1801 23.8429 32.1801 24.1573 32.0634 24.437C31.9298 24.757 31.5464 25.0109 30.7798 25.5186L18.7053 33.5151C17.7775 34.1295 17.3136 34.4368 16.9289 34.414C16.5937 34.3941 16.2841 34.2295 16.0816 33.9635C15.8491 33.6582 15.8491 33.1043 15.8491 31.9965V16.0036Z",
    fill: "#D34646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.3f5a0df9f0c98190c28f35925a410f78.svg";
export { ForwardRef as ReactComponent };